<template>
  <div>
    <el-row style=" margin-top: 40px;height: 120px;">
      <el-col :xl="11" :lg="11" :md="11" :sm="11" :xs="10" style="text-align: right;margin-right: 2%">声音告警：</el-col>
      <el-col :xl="10" :lg="10" :md="10" :sm="10" :xs="13" >
        <el-switch
            style="display: block;"
            v-model="voiceAlarmData.val"
            active-color="#13ce66"
            inactive-color="#ff4949"
            inactive-text="禁用"
            active-text="启用">
        </el-switch>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "voiceAlarm",
  props:["voiceAlarmData"],
  data(){
    return{

    }
  },
  created() {

  },
  methods:{
  }
}
</script>

<style scoped>

</style>
